export default "/signup/_next/static/chunks/fonts/inter-v3-latin-600-c1e9d3d67482a87f1290db6e86bd2415.eot";